import { Table } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";

export const StyledTable = styled(Table)(({ theme }) => ({
  "& .MuiTableCell-root": {
    padding: "12px",
  },
  "& .MuiTableHead-root": {
    "& .MuiTableCell-root": {
      backgroundColor: theme.palette.background.paper,
      borderBottom: "none",

      "&:first-of-type": {
        borderRadius: "10px 0px 0px 0px",
      },
      "&:last-of-type": {
        borderRadius: "0px 10px 0px 0px",
      },
      "&>p": {
        lineHeight: "12px",
      },
    },
  },
  "& .MuiTableBody-root": {
    "& .MuiTableCell-root": {
      height: "50px",

      "&:not(:last-of-type)": {
        borderRight: `1px solid ${lighten(theme.palette.secondary.light, 0.7)}`,
      },
    },

    "& .MuiTableRow-root": {
      "& .MuiTableCell-root": {
        "&:not(:last-of-type)": {
          borderRight: `1px solid ${lighten(theme.palette.secondary.light, 0.7)}`,
        },
      },
    },
  },
}));
